import { AlertTriangle, Info } from "lucide-react";
import { Modal } from "@/components/ui/Modal";
import { Button } from "@/components/ui/Button";

export interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  loading?: boolean;
  /** Padrão `danger` (ações destrutivas). Use `primary` para confirmações de execução. */
  confirmVariant?: "danger" | "primary";
}

export function ConfirmModal({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  loading = false,
  confirmVariant = "danger",
}: ConfirmModalProps) {
  const isPrimary = confirmVariant === "primary";
  return (
    <Modal
      open={isOpen}
      onClose={onCancel}
      title={title}
      size="sm"
      elevated
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="secondary" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button
            variant={isPrimary ? "primary" : "danger"}
            onClick={() => void onConfirm()}
            loading={loading}
          >
            {confirmLabel}
          </Button>
        </div>
      }
    >
      <div className="flex gap-3">
        <div
          className={
            isPrimary
              ? "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-brand-50"
              : "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-red-50"
          }
        >
          {isPrimary ? (
            <Info className="h-5 w-5 text-brand-600" />
          ) : (
            <AlertTriangle className="h-5 w-5 text-red-600" />
          )}
        </div>
        <p className="text-sm leading-relaxed text-slate-600 whitespace-pre-line">{message}</p>
      </div>
    </Modal>
  );
}
